import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueAnime from 'vue-animejs'
import VueParallaxJs from 'vue-parallax-js'

const EventBus = new Vue()

Vue.prototype.$eventBus = EventBus

Vue.use(VueAnime)
Vue.use(VueParallaxJs)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
